// The company's Google listing, read on 2026-10-15. Update GOOGLE_REVIEWS when the count moves.
export const GOOGLE_RATING = "4.9";
export const GOOGLE_REVIEWS = "1,495";
export const GOOGLE_URL = "https://maps.google.com/?cid=15062498827035001671";
